import React from "react";
import AssociationChainScreen from './association-chain/Panel';
import {BaseScreen} from "react-epharma-components";

interface Props {
    crud: {
      exportGrid: {
        show: boolean;
        permissionId: string;
      };
    };
  }

export default class AssociationChain extends React.Component<Props> {
    state = {
        data: [],
    }
    
    onSelect = (data: any[]) => {
        this.setState({ 
            data,
        });
    };

    showExport = () => {
        const { exportGrid } = this.props.crud;
    
        return exportGrid && exportGrid.show &&
          (!exportGrid.permissionId || (exportGrid.permissionId &&
            this.checkIfHasPermission(exportGrid.permissionId)));
    };

    checkIfHasPermission = (permissionId: string) => {
        const { hasPermission, permissionsIds } = this.context;
    
        return hasPermission(permissionId, permissionsIds);
    };

    render() {
        return (
            <BaseScreen 
                title="% Comissão Rede x Cliente" 
                description="" 
            >                
            <AssociationChainScreen></AssociationChainScreen>
            </BaseScreen>
        )
    }
}